import Vue from "vue";
import Router from "vue-router";
import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import Staff from "../pages/Dashboard/Staff";
import Orders from "../pages/Dashboard/Orders";
import Management from "../pages/Dashboard/Management";
import Analytics from "../pages/Dashboard/Analytics";

Vue.use(Router);

export const router = new Router({
    mode: "hash",
    routes: [
        {
            path: "/login",
            name: "login",
            component: () => import("../pages/Login/Login"),
        },
        {
            path: "/",
            roles: [],
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
                roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            },
            children: [
                {
                    path: "/",
                    name: "patient_list",
                    components: { default: Dashboard },
                    meta: {
                        requiresAuth: true,
                        roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                    },
                },
            ],
        },
        {
            path: "/staff",
            roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
                roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            },
            children: [
                {
                    path: "/",
                    name: "staff",
                    components: { default: Staff },
                    meta: {
                        requiresAuth: true,
                        roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                    },
                },
            ],
        },
        {
            path: "/management",
            roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
                roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            },
            children: [
                {
                    path: "/",
                    name: "management",
                    components: { default: Management },
                    meta: {
                        requiresAuth: true,
                        roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                    },
                },
            ],
        },
        {
            path: "/orders",
            roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
                roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            },
            children: [
                {
                    path: "/",
                    name: "orders",
                    components: { default: Orders },
                    meta: {
                        requiresAuth: true,
                        roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                    },
                },
            ],
        },
        {
            path: "/analytics",
            roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            component: DashboardLayout,
            meta: {
                requiresAuth: true,
                roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
            },
            children: [
                {
                    path: "/",
                    name: "analytics",
                    components: { default: Analytics },
                    meta: {
                        requiresAuth: true,
                        roles: ["ROLE_CENTRO", "ROLE_ENFERMERA"],
                    },
                },
            ],
        },
        {
            path: "*",
            redirect: "/",
        },
    ],
    linkExactActiveClass: "nav-item active",
});

router.beforeEach((to, from, next) => {
    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ["/login"];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem("instantcare_user");

    if (authRequired && !loggedIn) {
        return next("/login");
    }

    /**
     * Router permissions
     */

    let user = JSON.parse(localStorage.getItem("instantcare_user"));

    if (to.meta.roles) {
        const found = user.roles.some((r) => to.meta.roles.indexOf(r) >= 0);
        if (!found) {
            return next("/login");
        }
    }

    next();
});
